<template>
    <section id="checkout">
        <div id="breadcrumbs">
            <div class="bg-light py-3">
                <div class="container">
                    <div class="row">
                        <div class="col">
                            <div class="alert alert-warning">
                                Compras superiores a $599.00 no genera costo de envío (No aplica
                                suscripciones)
                            </div>
                        </div>
                    </div>
                    <div class="row">
                        <div class="col-md-12 mb-0 text-left">
                            <router-link to="/">Home</router-link>
                            <span class="mx-2 mb-0">/</span>
                            <strong class="text-black">Dirección de entrega-pago</strong>
                        </div>
                    </div>
                </div>
            </div>
        </div>
        <!-- #breadcrumbs -->
        <div class="site-section">
            <div class="container">
                <div class="row" >
                    <div class="col-12 col-sm-7 order-last order-sm-first" id="contactInfo">
                        <GuestForm @changeV="changeView"
                            @update="updateAddress" 
                            @updateUser="updateUser" 
                            v-show="!is_registered"
                            :accessData="true">
                        </GuestForm>
                        <address-card 
                            :address-data="addressData" 
                            v-show="is_registered">
                        </address-card>
                        <payment-methods-one-click
                            :addressData="addressData" 
                            v-if="is_registered"
                            :accessLogin="true"
                        ></payment-methods-one-click>
                    </div>
                    <div class="col-12 col-sm-5 order-first order-sm-last">
                        <div class="card">
                            <div class="card-body">
                                <product-checkout-list-subscriptions>
                                </product-checkout-list-subscriptions>
                            </div><!-- .card-body -->
                        </div><!-- .card -->
                    </div>
                </div><!-- .row -->
            </div> <!-- .container -->
        </div> <!-- .site-section -->
    </section>
</template>

<script>
// @ is an alias to /src
//import axios from "axios"
import Loading from "vue-loading-overlay";
import "vue-loading-overlay/dist/vue-loading.css";
import GuestForm from "@/components/User/GuestForm.vue";
import ProductCheckoutListSubscriptions from "@/components/Products/ProductCheckoutListSubscriptions.vue";
import AddressCard from "@/components/Address/AddressCard";
import AddressForm from "@/components/AddressForm.vue";
import CheckoutSubscriptions from './CheckoutSubscriptions.vue';
import PaymentMethodsOneClick from '../components/Payment/PaymentMethodsOneClick.vue';
const axios = require("axios");

export default {
    name: "GuestCheckout",
    components: {
        Loading,
        AddressForm,
        GuestForm,
        ProductCheckoutListSubscriptions,
        AddressCard,
        CheckoutSubscriptions,
        PaymentMethodsOneClick,
    },
    data() {
        return {
            is_loading: false,
            api_url: process.env.VUE_APP_SUSCRIPTIONS_ROUTE,
            base_url: process.env.VUE_APP_SUSCRIPTIONS_BASE_ROUTE,
            local_url: process.env.VUE_APP_SUSCRIPTIONS_LOCAL_ROUTE,
            is_registered: false,
            userData: {},
            products: [],
            addressData: {},
            showTotal: false,
            subscription:true,
            accessData:null
        };
    },
    mounted(){
        if(Object.keys(this.$route.params).length === 0){
            console.log('no se enviaron los parametros');
            this.$router.push({name:"home"});
        }
        else{
        this.products = this.$route.params;
        console.log('existen los parametros', this.products);
        }
    },
    created() {
        const script = document.createElement("script");
        script.src = "https://cdn.conekta.io/js/latest/conekta.js";
        script.async = true;
        document.body.appendChild(script);
        // Se verifica si el usuario esta logeado
        this.checkIsRegistered();

    },
    methods: {
        checkIsRegistered: function(){
            if ($cookies.get('uidmmkg') && $cookies.get('utoken') && this.addressData.id !== undefined){
                this.is_registered = true;
            }
        },
        changeView: function (value) {
            this.showTotal = value;
        },
        getdirections() {
            axios.get(this.url).then((data) => {
                this.directions = data.data;
            });
        },
        updateAddress: function (value) {
            console.info("Actualizando direccion en Checkout");
            console.info(value);
            this.addressData = value;
            this.checkIsRegistered();
        },
        updateUser: function(data){
            this.userData = data;
        },
        setProducts: function(data){
            this.products = data;
        }
    },

    onEdit(data) {
        //window.console.log("add edit" + data);
        this.form = data;
        this.form.isEdit = true;
    },
};
</script>

<style scoped>
.alert-warning {
    color: #856404 !important;
    background-color: #fff3cd !important;
    border-color: #ffeeba !important;
}
</style>